export enum AuctionTypeFilter {
  BUY_NOW = 'buy_now',
  OPEN = 'open',
  CLOSED = 'closed',
}
